import styled from "styled-components";
import { cuideoTheme } from "../../../../containers/themes/defaultTheme";

export const PickerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
`;

export const PickerLabel = styled.span`
  font-family: "Source Sans Pro", Helvetica, Arial, sans-serif;
  font-size: 0.9rem;
  font-weight: 600;
  color: ${cuideoTheme.palette.primary.main};
`;

export const PickerWheels = styled.div`
  display: flex;
  align-items: center;
`;

export const PickerColon = styled.span`
  font-size: 1.15rem;
  font-weight: 700;
  color: ${cuideoTheme.palette.primary.main};
  padding: 0 0.25rem;
`;
